import config from '@/config'
import useBackend from '@/hooks/useBackend'
import useError from '@/hooks/useError'
import { isRequired } from '@/utils/CustomErrors'

const { buildURL, setup, doDelete, doPost, getBaseUrl } = useBackend()

const { createErrorResponse } = useError()

setup('/ovpv3/public', config.microserviceBaseUrl, {
  responseSuccess: response => {
    return response.data
  },
  responseError: error => {
    return createErrorResponse(error)
  },
})

/**
 * Logic and API calls for the residence-permit-controller
 */
export default function useResidencePermitUpload() {
  /**
   * Get the URL
   * @param payload
   * @returns {string}
   */
  function createFileUrl({
    basketId = isRequired('basketId'),
    fileId = isRequired('fileId'),
    personId = isRequired('personId'),
    documentType, // optional parameter, only used for POST
  }) {
    const uri = [getBaseUrl.value, 'baskets', basketId, 'residencepermit', personId, fileId, documentType]
      .filter(x => !!x) // filter because of optional parameters
      .join('/')
    return buildURL(uri)
  }

  /**
   * @param payload
   * @returns {AxiosPromise}
   */
  function deleteFile(payload) {
    return doDelete(createFileUrl(payload), {})
  }

  /**
   * @param {Object} payload
   * @param {Blob} fileBlob
   * @param {Object} config
   * @returns {AxiosPromise<any>}
   */
  function uploadFile(payload, fileBlob, __config = {}) {
    // eslint-disable-next-line no-unused-vars
    const { documentType = isRequired('documentType') } = payload // required parameter for POST

    const formData = new FormData()
    const name = 'residencePermitFile'
    formData.append(name, fileBlob, fileBlob.name.replace('=', '_'))

    return doPost(createFileUrl(payload), formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      ...__config,
    })
  }

  function openFile(payload) {
    const fileUrl = createFileUrl(payload)
    const fileWindow = window.open(fileUrl, '_blank')
    fileWindow.focus()
  }

  return {
    createFileUrl,
    deleteFile,
    openFile,
    uploadFile,
  }
}
